import { TemplateDetailsGeneralFieldDto } from "@domain/project/template/property/project/details/general/template-details-general-field.dto";
import { Type } from "class-transformer";
import { IsOptional } from "class-validator";

export class TemplateProductListDto {
  @IsOptional()
  @Type(() => TemplateDetailsGeneralFieldDto)
  copyToClipboard?: TemplateDetailsGeneralFieldDto;
}
